import { useState } from 'react';
import { Handshake } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { ManualReferralModal } from './ManualReferralModal';
import type {
  ManualReferralEntitySearchItem,
  ManualReferralProfessionalRole,
} from '../../types/manual-referral.type';

type ManualReferralProfileButtonProps = {
  referredEntity: ManualReferralEntitySearchItem & {
    role: ManualReferralProfessionalRole;
  };
};

export const ManualReferralProfileButton = ({
  referredEntity,
}: ManualReferralProfileButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button type="button" variant="outline" onClick={() => setIsOpen(true)}>
        <Handshake className="mr-2 h-4 w-4" />
        Register referral
      </Button>
      {isOpen && (
        <ManualReferralModal
          open={isOpen}
          onOpenChange={setIsOpen}
          referredEntity={referredEntity}
        />
      )}
    </>
  );
};
